<template>
  <table style="width:100%;">
    <tr>
      <th style="text-align: left;">Name</th>
      <th style="text-align: left;">Assigned By</th>
      <th style="text-align: left;">Assigned At</th>
    </tr>
    <tr>
      <td>{{ portfolio.user || "Not Assigned" }}</td>
      <td>{{ portfolio.assigned_by || "Not Assigned" }}</td>
      <td>{{ portfolio.assigned_at | date }}</td>
    </tr>
  </table>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
  props: ["iso3"],
  data() {
    return {
      portfolio: {},
    };
  },
  created() {
    this.load();
  },
  watch: {
    iso3() {
      this.load();
    },
  },
  filters: {
    date(date) {
      date = moment(date);

      if (date.isValid(date)) {
        return date.format("DD/MM/YYYY hh:mm");
      } else {
        return "-";
      }
    },
  },
  methods: {
    // load the records into the data
    load() {
      axios
        .get("/psql/portfolios_view", {
          params: { iso3: `eq.${this.iso3}` },
          headers: { Accept: "application/vnd.pgrst.object+json" },
        })
        .then(response => {
          this.portfolio = response.data;
          console.log("Portfolios has been loaded successfully");
        })
        .catch(error => {
          console.error(error.response);
          this.$Notice.error({
            title: "Error",
            desc: "Portfolios failed to load",
            duration: 8,
          });
        });
    },
  },
};
</script>

<style lang="css"></style>
